const Style = {
    history: `relative group/history flex flex-col overflow-hidden rounded-xl border border-border
        bg-surface shadow-sm p-0`,
    submitBtn: `w-full h-10 px-5 text-white shadow-lg text-sm-bold transition-colors
                duration-150 bg-primary-500 rounded-lg
                focus:shadow-outline hover:bg-primary-700`,
    own: 'border-primary-200 bg-primary-50/50 dark:border-primary-900/70 dark:bg-primary-900/20',
    generalOwn: 'border-primary-200/70 bg-primary-100/40 dark:border-primary-900/60 dark:bg-primary-900/25',
    from: 'text-xs text-text-muted',
    name: 'text-sm font-medium text-text-primary',
    text: 'text-sm text-text-secondary',
    about: 'flex flex-wrap items-center gap-x-2 gap-y-0.5',
    details: 'flex items-center space-x-1',
    editIcon:
        'shadow-sm group/edit invisible group-hover/history:visible hover:cursor-pointer transition duration-300 ease-in-out',
    editInfo: 'absolute bottom-1 right-3 mr-2 mb-2',
    assigned: 'flex items-center space-x-1 text-primary-700 text-sm',
    icon: 'w-4 h-4 text-error',
    general: 'flex items-center justify-between gap-2 border-b border-border/80 px-3 py-2',
    date: 'text-xs text-text-muted whitespace-nowrap',
    comment: 'whitespace-pre-wrap px-3 py-2.5 text-sm leading-relaxed text-text-secondary',
    info: 'flex space-x-2 items-center',
    divider: 'border-t my-1 border-border',
};

export default Style;
